export const name = 'index'

export const REFRESH_DASHBOARD = `${name}/REFRESH_DASHBOARD`
export const REFRESH_DASHBOARD_SUCCESS = `${name}/REFRESH_DASHBOARD_SUCCESS`
export const REFRESH_DASHBOARD_ERROR = `${name}/REFRESH_DASHBOARD_ERROR`
